<div id="layout" class="sign_in f_col">
  <app-view-title fromRoute="pre-enroll" [chooseLangBtn]="false">{{(isPaymentError ? 'paymentError.title' : (api.env.formHasBookTimeSlotStep ? 'successPayment.booking.title' : 'successPayment.title')) | translate}}</app-view-title>
  <div class="scroll_wrapper resp_wrapper">
    <div class="resp_c-50 resp_scroll-wrapper_l">
        <app-view-deco-image class="mt_20 mb_20" [imageUrl]="isPaymentError ? 'assets/images/image_warn.svg' : 'assets/images/image_done.svg'"></app-view-deco-image>
        <app-paragraph class="mt_20" [innerhtml]="(isPaymentError ? 'DYN.paymentError.desc.' + isPaymentError : 'DYN.paymentError.desc.success') | translate"></app-paragraph>
        <div class="warning-container mt_10" *ngIf="longError">
            <fa-icon class="mr_20" size="xl" [icon]="'triangle-exclamation'"></fa-icon>
            <app-paragraph [innerHtml]="getLongError()"></app-paragraph>
        </div>
        <div class="warning-container mt_10" *ngIf="!isPaymentError && api.env.showPaymentInstructions && api.userInfo?.server.bank">
            <fa-icon class="mr_20" size="xl" [icon]="'building-columns'"></fa-icon>
            <app-paragraph [innerHTML]="'summary.bankTransfer' | translate : {bank: api.userInfo?.server.bank, batchId: cart.lastBatchId}"></app-paragraph>
        </div>
        <div class="btns-container">
          <div class="fullWidth flex f_center">
            <div class="menuButton-container flex f_center">
              <div class="ml_10 fullWidth flex f_col f_align_c">
                <app-button [initStartDebounce]="false" [showRemainingDebounceTime]="false" [debounceTimeInMilliseconds]="10000" size="xsm" color="transparent" border="true" formId="form" class="resp_minSize_l fullWidth" (btnClicked)="navClose()">{{'global.close' | translate}}</app-button>
              </div>
            </div>
          </div>
        </div>
    </div>

  </div>
  <div class="mb_20">
    <app-button color="transparent" border="true" formId="form" class=" resp_maxSize_l fullWidth" (btnClicked)="nav.to('dashboard')">{{'global.back' | translate}}</app-button>
  </div>
</div>
